import { type PayloadAction, createSlice } from '@reduxjs/toolkit';
import { type ModalInitialState } from './types';

const initialState: ModalInitialState = {
  isModalOpen: false,
  stack: [],
};

export const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openModal: (
      state,
      {
        payload,
      }: PayloadAction<{ modalType: string; modalData: Record<string, any> }>,
    ) => {
      state.isModalOpen = true;
      state.stack.push(payload);
    },
    closeModal: (state) => {
      state.stack.pop();
      state.isModalOpen = state.stack.length > 0;
    },
  },
});

export const { reducer: modalReducer } = modalSlice;
